module.exports = __webpack_public_path__ + "img/72600.23d7de2c.jpg";